import React, { useRef, useState, useCallback } from "react";
import { Button } from "reactstrap";
import { useSelector } from "react-redux";
import { useReactToPrint } from "react-to-print";
import { getDateTimestamp, renderMonth } from "../../../helpers/common";
import ResumeTemplateClassic from "./ResumeTemplates/ResumeTemplateClassic";
import ResumeTemplateModern from "./ResumeTemplates/ResumeTemplateModern";
import ResumeTemplateProfessional from "./ResumeTemplates/ResumeTemplateProfessional";
import ResumeTemplateElegant from "./ResumeTemplates/ResumeTemplateElegant"; // Added Elegant Template
import ResumeTemplateLoraineHudson from "./ResumeTemplates/ResumeTemplateLoraineHudson";

export const getCertificationValidity = (item) => {
  const issueMonth = item?.additional_fields?.issue_month;
  const issueYear = item?.additional_fields?.issue_year;

  const expirationMonth = item?.additional_fields?.expiration_month;
  const expirationYear = item?.additional_fields?.expiration_year;

  if (!expirationMonth) {
    return `Validity froms: ${renderMonth(
      issueMonth
    )} ${issueYear}. Does not expire`;
  }

  return `Validity: (${renderMonth(issueMonth)} ${issueYear} - ${renderMonth(
    expirationMonth
  )} ${expirationYear})`;
};

// Map template keys to components with new categories in small case
const TEMPLATE_COMPONENTS = {
  classic: ResumeTemplateClassic,
  modern: ResumeTemplateModern,
  professional: ResumeTemplateProfessional,
  elegant: ResumeTemplateElegant, // Added Elegant Template
  lorainehudson: ResumeTemplateLoraineHudson,
};

const ResumePreviewAndDownload = () => {
  const componentRef = useRef();
  const [currentTimestamp, setCurrentTimestamp] = useState(
    getDateTimestamp(new Date())
  );

  const defaultTemplate = "modern";

  // Get selected template object from redux (assume it's stored in state.resumeBuilder.selectedTemplate)
  // Default to "classic" if not set
  const selectedTemplate = useSelector(
    (state) => state.resumeBuilder.selectedTemplate
  );
  const selectedTemplateKey = selectedTemplate?.name
    ? selectedTemplate.name.toLowerCase()
    : defaultTemplate;

  const resumeBuilder = useSelector((state) => state.resumeBuilder.formData);
  const jobLocations = useSelector((state) => state.jobLocations.data) || [];
  const { experiences, certifications, qualifications } = useSelector(
    (state) => state.customer
  );

  // Pick the correct template component, fallback to classic
  const TemplateComponent =
    TEMPLATE_COMPONENTS[selectedTemplateKey] || ResumeTemplateClassic;

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `${resumeBuilder?.name || "Resume"} - ${currentTimestamp}`,
  });

  const handlePrintClick = useCallback(() => {
    setCurrentTimestamp(getDateTimestamp(new Date()));
    // Use setTimeout to ensure state update happens before print
    setTimeout(() => {
      handlePrint();
    }, 0);
  }, [handlePrint]);

  return (
    <div>
      <div className="resume-preview-and-download">
        <div className="text-end mb-3">
          <Button color="primary" outline onClick={handlePrintClick}>
            <i className="mdi mdi-download me-2"></i>
            Download PDF
          </Button>
        </div>
        <div className="resume-container" ref={componentRef}>
          <TemplateComponent
            formData={resumeBuilder}
            jobLocations={jobLocations}
            experiences={experiences}
            certifications={certifications}
            qualifications={qualifications}
          />
        </div>
      </div>
    </div>
  );
};

export default ResumePreviewAndDownload;
